<script>
import { toFormattedNumber } from '@/utils/number'

export default {
  props: {
    value: {
      type: Number,
      default: 0
    }
  },

  render() {
    return (
      <div style={{ textAlign: 'center', fontSize: '1.25rem' }}>
        ดอกเบี้ยที่ได้รับแล้วรวม:{' '}
        <span style={{ fontWeight: 'bold', fontSize: '1.5rem' }}>
          {toFormattedNumber(this.value, 2)}
        </span>
      </div>
    )
  }
}
</script>
